module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=LC - Saint Lucia.4bea1c81.svg";